
<template>
  <div>
    <Spiner :class="statusData.spinnerStatus ? '' : 'display_none'"/>

    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'3-4'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>
            제품 관리 - 3단계 : 제품 분류 {{ $route.query.product_division_two_level_ID === undefined ? '등록' : '수정' }}
          </p>
          <div class="Admin_PageHeader_btn">
            <button class="Admin_PageHeader_btn01" v-on:click="check_form">
              {{ $route.query.product_division_two_level_ID === undefined ? '등록' : '수정' }}
            </button>
          </div>
        </div>

        <div class="Admin_PageDetail">
          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_division_one_level_ID'>제품분류 1단계<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_division_one_level_ID"
                v-model="formData.productDivisionOneLevelID"
              >
                <option
                  v-for="item in statusData.productDivisionOneLevelIDArray"
                  :key="item.product_division_one_level_ID"
                  :value="item.product_division_one_level_ID"
                >
                  {{ item.product_division_one_level_kor_name }}
                </option>
              </select>
            </div>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_division_two_level_kor_name'>제품분류 2단계 한글명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                division_two_level='text'
                id = 'product_division_two_level_kor_name'
                maxLength="100"
                placeholder = "제품분류 2단계 한글명을 입력해 주세요."
                v-model="formData.productDivisionTwoLevelKorName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productDivisionTwoLevelKorNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_division_two_level_eng_name'>제품분류 2단계 영문명<span class="pointTextRed"> * </span></label>
              <input
                class="Admin_PageDetail_inputText"
                division_two_level='text'
                id = 'product_division_two_level_eng_name'
                maxLength="100"
                placeholder = "제품분류 2단계 영문명을 입력해 주세요."
                v-model="formData.productDivisionTwoLevelEngName"
              />
            </div>
            <p class="Admin_ErrorBox">{{errorData.productDivisionTwoLevelEngNameError}}</p>
          </div>

          <div class="Admin_PageDetail_BoxWrap">
            <div class="Admin_PageDetail_BoxDiv">
              <label for='product_division_two_level_activate'>사용 여부<span class="pointTextRed"> * </span></label>
              <select
                class="Admin_PageDetail_inputSelect"
                id="product_division_two_level_activate"
                v-model="formData.productDivisionTwoLevelActivate"
              >
                <option value='1'>사용</option>
                <option value='2'>미사용</option>
              </select>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import { ref } from 'vue'
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import Spiner from '../../Homepage/Section/Spiner.vue'
import {
  get_product_division_two_level_one,
  insert_product_division_two_level,
  update_product_division_two_level,
  get_product_division_one_level_use
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminProductDivisionTwoLevelManagementAdd',
  components: {
    AdminHeader: AdminHeader,
    AdminFooter: AdminFooter,
    Spiner: Spiner

  },
  setup () {
    return {
      formData: ref({
        productDivisionOneLevelID: 1,
        productDivisionTwoLevelKorName: '',
        productDivisionTwoLevelEngName: '',
        productDivisionTwoLevelActivate: 1
      }),
      errorData: ref({
        productDivisionTwoLevelKorNameError: '',
        productDivisionTwoLevelEngNameError: ''
      }),
      statusData: ref({
        spinnerStatus: false,
        productDivisionOneLevelIDArray: []
      })
    }
  },
  methods: {
    check_form: function () {
      let continue_add = true
      if (this.formData.productDivisionTwoLevelKorName === '') {
        this.errorData.productDivisionTwoLevelKorNameError = '제품분류 2단계 한글명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productDivisionTwoLevelKorNameError = ''
      }
      if (this.formData.productDivisionTwoLevelEngName === '') {
        this.errorData.productDivisionTwoLevelEngNameError = '제품분류 2단계 영문명을 입력해 주세요.'
        continue_add = false
      } else {
        this.errorData.productDivisionTwoLevelEngNameError = ''
      }
      if (continue_add) {
        this.statusData.spinnerStatus = true
        if (this.$route.query.product_division_two_level_ID === undefined) {
          insert_product_division_two_level(
            this.formData.productDivisionOneLevelID,
            this.formData.productDivisionTwoLevelKorName,
            this.formData.productDivisionTwoLevelEngName
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('등록이 완료되었습니다.')
            window.location.href = '/AdminProductDivisionTwoLevelManagement'
          })
        } else {
          update_product_division_two_level(
            this.$route.query.product_division_two_level_ID,
            this.formData.productDivisionOneLevelID,
            this.formData.productDivisionTwoLevelKorName,
            this.formData.productDivisionTwoLevelEngName,
            this.formData.productDivisionTwoLevelActivate
          ).then(() => {
            this.statusData.spinnerStatus = false
            alert('수정이 완료되었습니다.')
            window.location.href = '/AdminProductDivisionTwoLevelManagement'
          })
        }
      } else {
        alert('필수 입력값을 확인해주세요.')
      }
    }
  },
  mounted () {
    get_product_division_one_level_use().then((result_data) => {
      this.statusData.productDivisionOneLevelIDArray = result_data
      if (this.$route.query.product_division_two_level_ID !== undefined) {
        get_product_division_two_level_one(this.$route.query.product_division_two_level_ID).then((result) => {
          this.formData.productDivisionOneLevelID = result[0].product_division_one_level_ID_product_division_two_level
          this.formData.productDivisionTwoLevelKorName = result[0].product_division_two_level_kor_name
          this.formData.productDivisionTwoLevelEngName = result[0].product_division_two_level_eng_name
          this.formData.productDivisionTwoLevelActivate = result[0].product_division_two_level_activate
        })
      }
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/ProductManagement/AdminProductDivisionTwoLevelManagementAdd.vue